import { useState, useEffect } from "react";
import ClosedIcon from "../../utils/assets/client/closed-icon.png";
import OpenIcon from "../../utils/assets/client/open-icon.png";
import CancelIcon from "../../utils/assets/client/cancel-icon.png";
import QuickViewCard from "../../components/client/QuickViewCard";
import "../../styles/client.css";
import { Link } from "react-router-dom";
import searchSVG from "../../utils/assets/client/search.svg";
import { fetchAllTickets } from "../../actions/admin/tickets";
import FilterIcon from "../../utils/assets/client/filter.svg";
import DoughnutChart from "../../components/admin/DoughnutChart";
import { fetchTicketStatus } from "../../actions/admin/tickets";

const TicketsPage = () => {
  const [leadsData, setLeadsData] = useState([]);
  const [searchTicketsdata, setSearchTicketsData] = useState([])
  const [labeldata, setLabelData] = useState([])
  const [statusData, setStatusData] = useState([]);
  const [inputData, setInputdata] = useState({
    id: "",
    status: "",
    date: ""
  })
  const labelDataRef = [
    "Awaiting Arrival",
    "Awaiting Client Reply",
    ""
  ];

console.log("leadsData", leadsData);


  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchAllTickets(token).then((res) => {
      setLeadsData(res.data);
      setSearchTicketsData(res.data);
    });
    fetchTicketStatus(token).then((res) => {
      const titles = res.data.map((item) => item.title);


      setLabelData(titles)
    })



    // const computedDataSetValueRef = labelDataRef.map(
    //   (label) => res.data.filter((data) => data.status === label).length
    // );
    // setStatusData(computedDataSetValueRef);


  }, []);
  const labelData = [
    "Closed",
    "Open",
    "Cancelled"
  ];

  console.log("statuses", labelData);
  
  const handleFilterChange = (values) => {
    // Update filters state
    // Filter data
    const filtered = leadsData.filter((item) => {
      const invoiceIDMatch = !inputData.id || item.ticket_id.toString().includes(inputData.id.toString().trim());
  
      const statusMatch = !inputData.status || 
        item.status.toLowerCase().includes(inputData.status.toLowerCase());
  
      const dateMatch = !inputData.date || 
        item.created_at.slice(0, 10) === inputData.date; // expected format: YYYY-MM-DD
  
      return invoiceIDMatch && statusMatch && dateMatch;
    });
    console.log("worked", filtered);

    setSearchTicketsData(filtered)
    
  };


  const handleClearFilter = () => {
    setInputdata({
      id: "",
      status: "",
      date: ""
    });
    setSearchTicketsData(leadsData)
  }


  const dataSetValue = [1, 3, 2];
  return (
    // <div className="mx-3 d-flex justify-content-center align-items-center">
    //   <div className="w-100">
    //     <h3 className="f-24 my-4 p-0 px-lg-3 txt-stale">Quick View!</h3>
    //     <div className="row w-100 p-0 px-lg-3">
    //       <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex mb-2">
    //         <QuickViewCard Icon={ClosedIcon} title={"Closed"} />
    //       </div>
    //       <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex mb-2">
    //         <QuickViewCard Icon={OpenIcon} title={"Open"} />
    //       </div>
    //       <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 d-flex mb-2">
    //         <QuickViewCard Icon={CancelIcon} title={"Cancelled"} />
    //       </div>
    //     </div>
    //     <div>
    //       <div className="mx-3 my-4">
    //         <div className="row d-flex justify-content-between align-items-center">
    //           <h3 className="f-24 col-lg-6 col-md-6 col-sm-12 col-xs-12 txt-stale">
    //             Manage Tickets
    //           </h3>
    //           <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-lg-end">
    //             <button className="btn btn-success">Create Ticket</button>
    //           </div>
    //         </div>
    //         {/* <div className='card_radius border_bg_col mt-4'>
    //   <div className='row px-3 text-center d-flex justify-content-between align-items-center'>
    //     <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
    //     <input type="text" className='form-control width_lg_50  search-bar-space' placeholder='Search...'/>
    //     </div>
    //     <div className='d-flex col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-lg-end'>
    //     <div className="nav-item dropdown">
    //     <p className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown" aria-expanded="false">
    //     Status
    //     </p>
    //       <ul className="dropdown-menu">
    //         <li><a className="dropdown-item" href="#">Open</a></li>
    //         <li><a className="dropdown-item" href="#">Closed</a></li>
    //       </ul>
    //     </div>
    //     <div className="nav-item dropdown mx-4">
    //       <p className="nav-link  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    //         Date
    //       </p>
    //       <ul className="dropdown-menu p-3">
            
    //         <li className=''>
    //           <label className='form-label'>From :</label>
    //         <input type="date" className='form-control' name="" id="" />
    //         </li>
    //         <li className=''>
    //           <label className='form-label mt-2'>To :</label>
    //         <input type="date" className='form-control' name="" id="" />
    //         </li> 
    //         <button className='btn btn-success mt-3 btn-sm' >Submit</button>
    //        </ul>
    //     </div>
        
    //     </div>
    //     <hr className='mx-0 px-0 w-100 mb-2' />
    //   </div>
    //   <table className="table table-striped table-hover w-100 mb-0">
    //     <thead>
    //     <tr>
    //       <td>Ticket ID</td>
    //       <td>Invoice ID</td>
    //       <td>Date</td>
    //       <td>Device Issue</td>
    //       <td>Total</td>
    //       <td>Status</td>
    //       <td>Device Issue</td>
    //     </tr>
    //     </thead>
    //     <tbody>
        
    //     <tr>
    //       <td><Link to="/client/tickets/rma-2535">RMA-2535</Link></td>
    //       <td>-</td>
    //       <td>01-02-2024</td>
    //       <td>Nokia Lumia 610 Screen Replacement</td>
    //       <td>€0.00</td>
    //       <td>IN PROGRESS</td>
    //       <td><Link to="/client/tickets/rma-2535">Details</Link></td>
    //     </tr><tr>
    //       <td><Link>RMA-2535</Link></td>
    //       <td>-</td>
    //       <td>01-02-2024</td>
    //       <td>Nokia Lumia 610 Screen Replacement</td>
    //       <td>€0.00</td>
    //       <td>IN PROGRESS</td>
    //       <td><Link>Details</Link></td>
    //     </tr><tr>
    //       <td><Link>RMA-2535</Link></td>
    //       <td>-</td>
    //       <td>01-02-2024</td>
    //       <td>Nokia Lumia 610 Screen Replacement</td>
    //       <td>€0.00</td>
    //       <td>IN PROGRESS</td>
    //       <td><Link>Details</Link></td>
    //     </tr>
    //     </tbody>
       
    //   </table>
    //   </div> */}
    //         <div className="w-100 my-3">
    //           <div className="row card_radius border_bg_col overflow-hidden">
    //             <div className="d-flex justify-content-between align-items-center bg_color_gray">
    //               <p className="txt-head  mb-0 p-2">View Ticket (s)</p>
    //               <div>
    //                 <button className="btn btn-sm bg-black text-white">
    //                   Create Ticket
    //                 </button>
    //                 {/* <div className="input-group">
    //           <input type="text" className="form-control" placeholder="Search..."  />
    //           <span className="input-group-text" id="basic-addon1"><img src={searchSVG} width={20} alt="search" /></span>
    //         </div> */}

    //                 {/* <input type="text" className="form-control" placeholder="Search..." /> */}
    //               </div>
    //             </div>

    //             <table className="table  table-bordered table-striped table-hover mb-0">
    //               <thead>
    //                 <tr>
    //                   <td>Ticket ID</td>
    //                   <td>Invoice ID</td>
    //                   <td>Date</td>
    //                   <td>Device Issue</td>
    //                   <td>Total</td>
    //                   <td>Status</td>
    //                   <td></td>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {leadsData.length > 0
    //                   ? leadsData.map((item) => {
    //                       return (
    //                         <tr>
    //                           <td> <Link> {item.id} </Link> </td>
    //                           <td>Invoice ID</td>
    //                           <td>Date</td>
    //                           <td>Device Issue</td>
    //                           <td>Total</td>
    //                           <td>{item.status}</td>
    //                           <td>Device</td>
    //                         </tr>
    //                       );
    //                     })
    //                   : ""}
    //               </tbody>
    //             </table>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="container-fluid bg_color_gray">
        <div className="row">
          <div>
          <h4 className="my-3 px-2">Quick View</h4>
          </div>
        </div>
        {/* doughnut chart and search */}
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            
            <div className="card  text-start border_bg_color rounded shadow d-flex justify-content-center align-items-center">
              
              <DoughnutChart
                labelData={labelData}
                dataSetValue={dataSetValue}
                chartName="Tickets by Status"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-3 mt-lg-0">
            <div className="card p-3 border_bg_color rounded shadow ">
              <p className="f-24">Search Filters</p>
              <div className="row d-flex justify-content-start align-items-center">
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label className="form-label">ID</label>
                <input type="text" value={inputData.id} onChange={(e) => setInputdata({...inputData, id: e.target.value})} className="form-control" placeholder="Search ID" />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <label className="form-label">Status</label>
                <select className="form-select" name="" id=""
                value={inputData.status}
                onChange={(e) => setInputdata({...inputData, status: e.target.value})}
                >
                <option value="" selected>Select Status</option>

                    <option value="Approved">Approved</option>
                    <option value="Declined">Declined</option>
                </select>
                {/* <input type="text" className="form-control" placeholder="" /> */}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 my-3">
                <label className="form-label">Date</label>
                <input 
                value={inputData.date}
                onChange={(e) => setInputdata({...inputData, date: e.target.value})}
                type="date" className="form-control" />
              </div>
              </div>
              <div className=" d-flex justify-content-start align-items-start mt-2">
                <button onClick={() => handleClearFilter()} className="btn bg-black text-white d-flex justify-content-center align-items-center">
                  <img src={FilterIcon} width={20} alt="filter" />
                  <span className="mx-2" >Clear Filter</span>
                </button>
                <button onClick={() => handleFilterChange()} className="btn bg-black text-white mx-3">
                  Search{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* table start */}
        <div className="row">
        <div className="my-3 ">
          <div className="rounded shadow border_bg_col overflow-hidden">
            <div className="d-flex justify-content-start align-items-center bg-black">
            <p className="txt-head  mb-0 p-2 px-3 text-white">
             Manage Tickets (s)
            </p>
            {/* <div>
            <div className="input-group">
              <input type="text" className="form-control card_radius" placeholder="Search..."  />
              <span className="input-group-text card_radius" id="basic-addon1"><img src={searchSVG} width={20} alt="search" /></span>
          </div>

           </div> */}
            </div>

           {!leadsData.length > 0 ? (
              <table className="table table-bordered table-striped table-hover mb-0">
                <thead>
                <tr>
                   <td>Ticket ID</td>
                      <td>Lead ID</td>
                       <td>Date</td>
                       <td>Device Issue</td>
                       <td>Due on</td>
                       <td>Total</td>
                       <td>Status</td>
                       <td></td>
                     </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colspan="6"
                      class="table-active"
                      className="text-center txt-p"
                    >
                      No Records
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <table className="table table-hover mb-0">
                <thead>
                <tr>
                      <td className="px-4">Ticket ID</td>
                       <td>Lead ID</td>
                       <td>Date</td>
                       <td>Device Issue</td>
                       <td>Due on</td>
                       <td>Total</td>
                       <td>Status</td>
                       <td>Remarks</td>
                     </tr>
                </thead>
                <tbody>
                  {searchTicketsdata.length > 0 &&
                    searchTicketsdata?.map((item) => {
                      return (
                        <tr style={{ fontWeight: 400 }}>
                               <td className="px-4" > <Link style={{fontWeight: "500"}} to={`/client/tickets/${item.id}`} className="link_text">{item.ticket_id} </Link> </td>
                               <td> <Link className="link_text"> {item?.lead?.lead_id} </Link> </td>
                               <td>
                               {item.created_at
                            ? new Date(item.created_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                               </td>
                               <td>{item?.lead?.lead_items[0]?.defects[0]?.title}</td>
                               <td>{item?.due_on ? item?.due_on : "-"}</td>

                               <td>£ {item.total_price + item.total_tax}</td>
                               <td>
                               {/* <span className="badge p-2" style={{backgroundColor: `${item.color_code}`, fontSize: "12px"}}>{item.status}</span> */}
                               <span className="badge p-2" style={{backgroundColor: 'red', fontSize: "12px"}}>{item.status}</span>
                               </td>
                               <td>Remarks</td>
                            </tr>
                      );
                    })}
                </tbody>
              </table>
            )}
          </div>
        </div>
        </div>
      </div>
  );
};

export default TicketsPage;
